import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    title: 'Your Balance in the Sonic Vault',
    tvlLabel: '~ {value} LBTC',
  },
};
